module.exports = __webpack_public_path__ + "img/pyf.bab3b7a5.svg";